import { render, staticRenderFns } from "./BaseTextRow.vue?vue&type=template&id=ac216670&scoped=true&"
import script from "./BaseTextRow.vue?vue&type=script&lang=js&"
export * from "./BaseTextRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextRow.vue?vue&type=style&index=0&id=ac216670&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac216670",
  null
  
)

export default component.exports